
const toutch = document.querySelector(".toutch--js");
const known = document.querySelector(".known--js");
const view = document.querySelector(".view--js");
const source = document.querySelector(".source--js");
const view2 = document.querySelector(".view2--js");
const source2 = document.querySelector(".source2--js");
const view3 = document.querySelector(".view3--js");
const source3 = document.querySelector(".source3--js");
const mail = document.querySelector(".mail--js");
const git = document.querySelector(".git--js");
const thing = document.querySelector(".thing--js");
const linkedin = document.querySelector(".linkedin--js");
const facebook = document.querySelector(".facebook--js");
const instagram = document.querySelector(".instagram--js");
const twitter = document.querySelector(".twitter--js");

thing.addEventListener('click', () => {
    alert('Error, the specified page does not exist')
});